import { panelTypes } from '../../common/panel/constants'
import { getUnique } from '../../helpers/common'
import { COMPANY_TYPES } from '../../utils/common'
import { PANELS } from './constant'
import SummaryService from './store/SummaryService'

export const getKeyPanels = (companyType) => {
  const keys = Object.values(PANELS)
  return [
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
    COMPANY_TYPES.NON_BANK,
  ].includes(companyType)
    ? keys.filter((key) => key !== PANELS.SCORE)
    : [COMPANY_TYPES.INSURANCE, COMPANY_TYPES.FUNDS].includes(companyType)
    ? keys.filter(
        (key) =>
          ![
            PANELS.SCORE,
            PANELS.TOP_INDUSTRY_PLAYERS,
            PANELS.KEY_FINANCIALS,
          ].includes(key),
      )
    : keys
}

export const saveTemplate = async (data, companyType) => {
  try {
    if (data.templateId) {
      const res = await SummaryService.updateTemplate({
        summaryTemplateName: data.templateName,
        summaryTemplateData: JSON.stringify(data.panels),
        summaryTemplateId: data.templateId,
        templateType: companyType,
      })
      return res.success
    } else {
      const res = await SummaryService.saveTemplate({
        summaryTemplateName: data.templateName,
        summaryTemplateData: JSON.stringify(data.panels),
        templateType: companyType,
      })
      return res.success
    }
  } catch {
    return false
  }
}

export const getDetailPanel = (key, isUserLite) => {
  switch (key) {
    case PANELS.COMPANY_OVERVIEW:
      return {
        id: getUnique(),
        key: PANELS.COMPANY_OVERVIEW,
        type: panelTypes.FULL_SIZE,
        label: 'companySummary.' + PANELS.COMPANY_OVERVIEW,
      }
    case PANELS.OWNERSHIP_AND_GROUP:
      return {
        id: getUnique(),
        key: PANELS.OWNERSHIP_AND_GROUP,
        type: panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.OWNERSHIP_AND_GROUP,
      }
    case PANELS.KEY_FINANCIALS:
      return {
        id: getUnique(),
        key: PANELS.KEY_FINANCIALS,
        type: isUserLite ? panelTypes.FULL_SIZE : panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.KEY_FINANCIALS,
      }
    case PANELS.SCORE:
      return {
        id: getUnique(),
        key: PANELS.SCORE,
        type: panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.SCORE,
      }
    case PANELS.RECENT_NEWS:
      return {
        id: getUnique(),
        key: PANELS.RECENT_NEWS,
        type: panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.RECENT_NEWS,
      }
    case PANELS.COMPANY_ALERTS:
      return {
        id: getUnique(),
        key: PANELS.COMPANY_ALERTS,
        type: panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.COMPANY_ALERTS,
      }
    case PANELS.TOP_INDUSTRY_PLAYERS:
      return {
        id: getUnique(),
        key: PANELS.TOP_INDUSTRY_PLAYERS,
        type: panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.TOP_INDUSTRY_PLAYERS,
      }
    case PANELS.TOP_COMPARABLE_PLAYERS:
      return {
        id: getUnique(),
        key: PANELS.TOP_COMPARABLE_PLAYERS,
        type: panelTypes.FULL_SIZE,
        label: 'companySummary.' + PANELS.TOP_COMPARABLE_PLAYERS,
      }
    case PANELS.FILING_STATUS:
      return {
        id: getUnique(),
        key: PANELS.FILING_STATUS,
        type: panelTypes.HALF_SIZE,
        label: 'companySummary.' + PANELS.FILING_STATUS,
      }
    default:
      return {}
  }
}
